export enum InputModes {
  none = 'none',
  text = 'text',
  decimal = 'decimal',
  numeric = 'numeric',
  tel = 'tel',
  search = 'search',
  email = 'email',
  url = 'url',
}
